import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M3 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M17 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M6.5 17.5l5.5 -4.5l5.5 4.5","key":"svg-3"}],["path",{"d":"M12 7l0 6","key":"svg-4"}]]

const IconHierarchy = createReactComponent('outline', 'hierarchy', 'Hierarchy', __iconNode);

export default IconHierarchy;